const routes = [
  {
    path: 'partstatus-management',
    name: 'partstatusManagement',
    component: () => import(/* webpackChunkName: "calibration-app" */ './views/Index.vue'),
    meta: {
      // permissionRequired: true,
    },
  },
];

export default routes;
